import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import moment from "moment";

const styles = StyleSheet.create({
  page: {
    paddingTop: 30,
    paddingBottom: 30,
    paddingHorizontal: 30,
    fontFamily: "Helvetica",
    fontSize: 14,
    lineHeight: 1.6,
  },
  chart: {
    width: "100%",
    height: 350,
    marginBottom: 25,
  },
  section: {
    marginBottom: 20,
  },

  title_header: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 12,
  },
  title_header_2: {
    fontSize: 15,
    fontWeight: "bold",
    marginBottom: 6,
  },
  question: {
    fontSize: 13,
    marginBottom: 4,
  },
  answer: {
    fontSize: 12,
    marginBottom: 10,
  },
  centerPage: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  centerText: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 4,
  },
  date_style: {
    fontSize: 16,
  },
});

const ResponsePDF = ({
  chartImage,
  sevenDimensions,
  eightAspects,
  userName,
  submittedDate,
}) => (
  <Document>
    {" "}
    <Page size="A4" style={styles.page} wrap>
      <View style={styles.centerPage}>
        <Text style={[styles.centerText, { marginBottom: 10 }]}>
          SEOL Map Assessment
        </Text>
        <Text style={styles.centerText}>Name : {userName}</Text>
        <Text style={styles.date_style}>
          Date : {moment(submittedDate).format("YYYY-MM-DD")}
        </Text>
      </View>
    </Page>
    <Page size="A4" style={styles.page} wrap>
      {/* CHART */}
      {chartImage && (
        <View style={{ width: 500, height: 500 }}>
          <Image
            src={chartImage}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </View>
      )}

      {/* {chartImage && <Image src={chartImage} style={styles.chart} />} */}

      {/* SEVEN DIMENSIONS */}
      <Text style={styles.title_header}>
        Your Answers - The Seven Dimensions
      </Text>

      {sevenDimensions.map((item, i) => (
        <View key={i} style={styles.section} wrap>
          <Text style={styles.title_header_2}>{item.name} : </Text>

          <Text style={styles.question}>{item.q1}</Text>
          <Text style={styles.answer}>{item.a1}</Text>

          <Text style={styles.question}>{item.q2}</Text>
          <Text style={styles.answer}>{item.a2}</Text>
        </View>
      ))}

      {/* EIGHT ASPECTS */}
      <Text style={styles.title_header}>
        Your Answers - The Eight Aspects of Wealth
      </Text>

      {eightAspects.map((item, i) => (
        <View key={i} style={styles.section} wrap>
          <Text style={styles.title_header_2}>{item.name} : </Text>

          <Text style={styles.question}>{item.q1}</Text>
          <Text style={styles.answer}>{item.a1}</Text>

          <Text style={styles.question}>{item.q2}</Text>
          <Text style={styles.answer}>{item.a2}</Text>
        </View>
      ))}
    </Page>
  </Document>
);

export default ResponsePDF;
